import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-metalayoutselector',
  templateUrl: './metalayoutselector.component.html',
  styleUrls: ['./metalayoutselector.component.scss']
})
export class MetaLayoutSelectorComponent implements OnInit {
  
  isLoading = false;
  metaobjectId = "";
  metaobjectName = "";
  metalayoutId = "";
  metalayoutName = "";
  displayName = "";
  action = "";
  mode = "New";
  
  constructor(private route: ActivatedRoute, private router: Router) { }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.mode = this.route.snapshot.params.mode;
      this.metaobjectId = this.route.snapshot.params.metaobjectid;
      this.metaobjectName = this.route.snapshot.params.metaobjectname;
      if(this.mode.toLowerCase().trim() == 'edit'){
        this.metalayoutId = this.route.snapshot.params.metalayoutid;
        this.metalayoutName = this.route.snapshot.params.metalayoutname;
        this.displayName = this.route.snapshot.params.displayname;
        this.action = this.route.snapshot.params.action;
      } 
    });

    this.isLoading = true;

    if (this.action.toLowerCase().trim() == 'new') {
      this.router.navigateByUrl('/home/metalayoutnew/' + this.mode + '/' + this.metalayoutId + '/' + this.metalayoutName + '/' + 
            this.action + '/' +  this.metaobjectId + '/' + this.metaobjectName );
    }
    else if (this.action.toLowerCase().trim() == 'view') {
      this.router.navigateByUrl('/home/metalayoutview/' + this.mode + '/' + this.metalayoutId + '/' + this.metalayoutName + '/' + 
            this.action + '/' +  this.metaobjectId + '/' + this.metaobjectName );
    }
    else if (this.action.toLowerCase().trim() == 'quickcreate') {
      this.router.navigateByUrl('/home/metalayoutquick/' + this.mode + '/' + this.metalayoutId + '/' + this.metalayoutName + '/' + 
            this.action + '/' +  this.metaobjectId + '/' + this.metaobjectName );              
    }
    else{
      //
    }

  }

}
